import React, { useState, useEffect, useRef } from "react";
import GoalOption from "./GoalOption";
import useClickOutside from '../useClickOutside';
import SignInModal from './SignInModal';
import Modal from '../Modal';

const GoalSelector = ({options, initialActive, renderSvg, prependText, fireAmplitude, ampEventType, currentUserId, preSelected, type}) => {
  const [active, setActive] = useState(initialActive)
  const [open, setOpen] = useState(false)
  const [selected, setSelected] = useState(preSelected ? true : false)
  const [customGoalAdded, setCustomGoalAdded] = useState(false)

  const goalSelector = useRef("menu");
  useClickOutside(goalSelector, () => {
    setOpen(false);
  });

  useEffect(() => {
    if(active !== initialActive) {
      setSelected(true)
    }
  }, [active])

  const renderDropdown = () => {
    return Object.keys(options).map((option) => {
      return <GoalOption 
                key={option}
                option={option}
                setActive={setActive}
                active={active}
                setCustomGoalAdded={setCustomGoalAdded}
                customGoalAdded={customGoalAdded}
                fireAmplitude={fireAmplitude}
                ampEventType={ampEventType}
                initialActive={initialActive}
                options={options}
                type={type}
              />
    })
  }

  const renderIcon = () => {
    let cssClass = selected ? "fa fa-edit" : "fas fa-chevron-down"
    return <i className={cssClass}/>
  }

  const renderPrependText = () => {
    if(selected) {
      return <span>{prependText}</span>
    }
  }

  const renderActive = () => {
    if(selected) {
      return (
        <div>
          {renderPrependText()}
          <span className="active-text">{active}</span>
        </div>
      )
    } else {
      return <span>{active}</span>
    }
  }

  const handleDropdownClick = () => {
    if(!currentUserId) {
      Modal.open({
        children: <SignInModal/>})
    } else {
      setOpen(!open)
    }
  }

  return (
    <div className="large-6 medium-12 small-12 columns">
      <div className="goals-container" onClick={handleDropdownClick} ref={goalSelector}>
        <div className="active-goal row collapse">
          <div className="small-10 columns goal-container">
            {renderSvg()}
            {renderActive()}
          </div>
          <div className="small-2 columns chevron-container">
            {renderIcon()}
          </div>
        </div>
        <div className={`goal-dropdown ${open ? 'open' : ''}`}>
          {renderDropdown()}
        </div>
      </div>
    </div>
  )
}

export default GoalSelector;
